import React from 'react';

const TaskManagementIcon = ({ width = 16, height = 16, color = 'currentColor', className }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M2 3.5A1.5 1.5 0 0 1 3.5 2h9A1.5 1.5 0 0 1 14 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 12.5v-9z"
        stroke={color}
        strokeWidth="1.3"
        fill="none"
      />
      <path
        d="M5 6h6M5 8h6M5 10h4"
        stroke={color}
        strokeWidth="1.3"
        strokeLinecap="round"
      />
      <circle
        cx="3.5"
        cy="6"
        r="0.5"
        fill={color}
      />
      <circle
        cx="3.5"
        cy="8"
        r="0.5"
        fill={color}
      />
      <circle
        cx="3.5"
        cy="10"
        r="0.5"
        fill={color}
      />
    </svg>
  );
};

export default TaskManagementIcon;